import { useEffect } from "react";

// UTILS
import { closeModal } from "../reducers/modalReducer";

// HOOKS
import { useAppDispatch, useAppSelector } from "../app/hooks";


const useAlertFeedback = (id: string) => {
  const dispatch = useAppDispatch();
  const { modalName, modalPrimaryButton } = useAppSelector(
    (state) => state.modal,
  );

  const handleClose = () => dispatch(closeModal());

  // An alert left open by a previous step must not reappear on mount
  useEffect(() => {
    handleClose();
  }, []);

  return {
    isOpen: !!id && modalName === id,
    onClose: handleClose,
    primaryAction: {
      text: modalPrimaryButton?.text,
      onClick: () => {
        modalPrimaryButton?.action();
        handleClose();
      },
    },
    secondaryAction: {
      text: "No, volver",
      onClick: handleClose,
    },
  };
};

export default useAlertFeedback;
